/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 10.06.17.
 */

import alt from "../alt";
import LogActions from "./LogActions";

/**
 * Log store - stores all logging messages.
 */
class LogStore {
    constructor() {
        this.state = {
            lastMessage: null
        };
        this.bindActions(LogActions);
        this.messages = [];
    }

    onDebug(message) {
        this.logMessage({
            message: message,
            level: "debug"
        });
    }

    onInfo(message) {
        this.logMessage({
            message: message,
            level: "info"
        });
    }

    onWarn(message) {
        this.logMessage({
            message: message,
            level: "warn"
        });
    }

    onError(message) {
        this.logMessage({
            message: message,
            level: "error"
        });
    }

    onException(e) {
        this.logMessage({
            message: e.message,
            exception: e,
            level: "exception"
        });
    }

    onClientError(info) {
        this.logMessage(info);
    }

    onClearError() {
        if (this.state.lastMessage)
            this.setState({
                lastMessage: null
            });
    }

    logMessage(info) {
        info.timestamp = new Date();
        if (!info.status) info.status = 0;
        this.setState({lastMessage: info});
        this.messages.push(info);
    }
}

/**
 *
 * @type {AltJS.AltStore<LogState>|LogStore}
 */
let logStore = alt.createStore(LogStore, 'LogStore');
export default logStore;
